import '/assets/styles/sections/child-form.scss';

// Deps
import { useState, useEffect } from 'react'
import parse from 'date-fns/parse'
import subYears from 'date-fns/subYears'
import addYears from 'date-fns/addYears'

// Partials
import Icon from '@wearetla/tla-essentials-tools/partials/icon'
import Btn from '/views/partials/btn'
import Loader from '/views/partials/loader'
import { Input, Form, FormFeedback } from '/views/partials/forms'

// Services
import userServices from '/services/user'

// Data
import childGenders from '/data/genders-children'
import { useBreakpoints } from '@wearetla/tla-essentials-tools/utilities/breakpoints'
const minBirthDate = subYears(new Date(), 17);
const maxBirthDate = addYears(new Date(), 1);

const ChildForm = ({ className, childID, onSuccess }) => {
	const { mobile } = useBreakpoints();

	const [child, setChild] = useState(childID ? null : false);
	const [submitting, setSubmitting] = useState(false);
	const [feedbackData, setFeedbackData] = useState(false);
	const [selectedGender, setSelectedGender] = useState(null);

	const [ birthDate, setBirthDate ] = useState(null);

	useEffect(() => {
		if (childID) {
			userServices.getChild(childID).then((payload) => {
				setSelectedGender(childGenders.find(g => g.value === payload.gender));
				setChild({
					...payload,
				});
				setBirthDate(parse(payload.birthdate, 'yyyy-MM-dd', new Date()))
			}).catch(() => {
				// close();
			});
		}
	}, [childID])

	const submit = (formFields) => {
		setSubmitting(true);
		setFeedbackData(false);

		const submitData = {
			...formFields,
			birthdate: formFields.birthdate.split('/').reverse().join('-'),
		}

		if (childID) {
			userServices.updateChild(childID, submitData).then(() => {
				onSuccess();
			}).catch((message) => {
				setFeedbackData(message);
				setSubmitting(false);
			});
		}
		else {
			userServices.addChild(submitData).then(() => {
				onSuccess();
			}).catch((message) => {
				setFeedbackData(message);
				setSubmitting(false);
			});
		}
	}

	return (
		<Form className={'section child-form ' + className} onSubmit={submit}>
			<div className="form-body loader-container">
				<Loader loading={child === null} />
				<div className="form-iconarea">
					<Icon className="iconarea-icon" name={selectedGender ? selectedGender.key : 'child'} />
				</div>
				<div className="form-formwrap grid-container">
					<FormFeedback
						focusOnMessage
						displayFormValidation
						genericValidationMessage="Lütfen eksik ve hatalı alanları doldurun."
						data={feedbackData}
						grid />
					<div className="row">
						<div className="col">
							<Input
								inline={mobile}
								disabled={submitting}
								type="radio"
								id="child_gender"
								options={childGenders}
								value={selectedGender}
								onChange={setSelectedGender}
								validation={{
									required: 'Bebeğinizin cinsiyetini seçmelisiniz.',
								}}
								autoComplete="sex"
								label="Bebeğinizin Cinsiyeti"
								name="gender" />
						</div>
					</div>
					<div className="row">
						<div className="col">
							<Input
								z="3"
								disabled={submitting}
								id="child_birth_date"
								type="date"
								className="form-field"
								label="Doğum Tarihi"
								minDate={minBirthDate}
								maxDate={maxBirthDate}
								validation={{
									date: 'Geçerli bir doğum tarihi girmelisiniz.',
								}}
								value={birthDate}
								onChange={(value) => { setBirthDate(value); }}
								name="birthdate" />
						</div>
					</div>
					<div className="row">
						<div className="col">
							<Input
								disabled={submitting}
								id="child_name"
								type="text"
								className="form-field"
								label="Bebeğinizin Adı"
								validation={{
									required: 'Bir isim girmelisiniz.',
									text: 'Geçerli bir isim girmelisiniz.',
								}}
								value={child ? child.name : undefined}
								autoComplete="given-name"
								name="name" />
						</div>
					</div>
				</div>
			</div>
			<div className="form-controls">
				<Btn
					loading={submitting}
					disabled={submitting || child === null}
					type="submit"
					className={
						(mobile ? 'primary' : 'dark') +
						(mobile ? ' block' : '') +
						(mobile ? ' big' : '')
					}>
					{childID === false ? 'Bebek Ekle' : 'Bebek Bilgisini Güncelle'}
				</Btn>
			</div>
		</Form>
	)
}

ChildForm.defaultProps = {
	className: '',
	childID: false,
}

export default ChildForm;